// extracted by css-extract-rspack-plugin
export default {"google_play_button_override":"gSJmS","googlePlayButtonOverride":"gSJmS","#":"EuumG","badge":"N_e5p","get_it_on":"dcGbz","getItOn":"dcGbz","store":"h3PZu"};